import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { EmptyState, PageHead } from '../../components/ui/common';
import { MessagesLog } from '../../features/B2b/MessagesLog';
import { parseMessagesSearch, type MessagesSearch } from '../../features/B2b/search';
import { useCan } from '../../lib/session';

/** Message log (Outbox) — lane B2b-web. Filters + the open message live in the URL: ?status ?client|clientId ?type ?date ?q ?open */
export const Route = createFileRoute('/_app/messages')({
  validateSearch: (s: Record<string, unknown>): MessagesSearch => parseMessagesSearch(s),
  component: MessagesPage,
});

function MessagesPage() {
  const can = useCan();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const setSearch = useCallback(
    (patch: Partial<MessagesSearch>, replace = false) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace }),
    [navigate],
  );
  if (!can('logs.messages.view')) {
    return (
      <>
        <PageHead title="לוג הודעות" />
        <EmptyState icon="shield" title="אין לך הרשאה לצפות בלוג ההודעות" text="מנהל המערכת יכול לתת לך הרשאת צפייה בלוג ההודעות." />
      </>
    );
  }
  return <MessagesLog search={search} setSearch={setSearch} />;
}
